module.exports = __webpack_public_path__ + "img/5-2_Create_Graph.c96fc03e.png";